// src/providers/consumeProvider.ts
import { DataProvider } from "react-admin";
import { appConfig } from "@/commons";
import { Voucher, VoucherStats } from "@/types";
import { httpClient } from "@/utilities";

const apiUrl = appConfig.api.baseUrl;

export type ConsumeProvider = Partial<DataProvider> & {
  consumeVoucher: (args: {
    code: string;
    pseudo: string;
    invoice_amount: number;
  }) => Promise<{ data: Voucher }>;

  getVoucherStats: () => Promise<{ data: VoucherStats }>;
};

const DEFAULT_VOUCHER_STATS: VoucherStats = {
  entity_id: "",
  bogo_count: 0,
  bogo_quantity: 0,
  bogo_claimed: 0,
  bogo_consumed: 0,

  free_product_count: 0,
  free_product_quantity: 0,
  free_product_claimed: 0,
  free_product_consumed: 0,

  discount_count: 0,
  discount_quantity: 0,
  discount_claimed: 0,
  discount_consumed: 0,

  gift_card_count: 0,
  gift_card_quantity: 0,
  gift_card_claimed: 0,
  gift_card_consumed: 0,
};

const consumeProvider: ConsumeProvider = {
  async consumeVoucher({ code, pseudo, invoice_amount }) {
    const { json } = await httpClient(`${apiUrl}/vouchers/consume`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({ code, pseudo, invoice_amount }),
    });

    const payload = json?.voucher ?? json;

    if (!payload) {
      throw new Error("Invalid API response: No voucher data");
    }

    return {
      data: {
        id: payload.id ?? payload.code ?? "consume",
        ...payload,
      },
    };
  },

  async getVoucherStats() {
    const { json } = await httpClient(`${apiUrl}/vouchers/stats`, {
      method: "GET",
    });

    const data = json?.data ?? json;

    return {
      data: {
        ...DEFAULT_VOUCHER_STATS,
        ...(data ?? {}),
      },
    };
  },
};

export default consumeProvider;
